import React, { useEffect, useState } from 'react';
import { Image, View } from 'react-native';
import LandingImage from 'assets/landing.jpg';
import { IS_WEB } from 'src/constants';
import { cleanUrl, transparent } from 'src/utils';
import styled from 'styled-components/native';
import { LinearGradient } from 'expo-linear-gradient';
import DownloadOurApp from './DownloadOurApp';

const SIDEBAR_WIDTH = 462;
const GRADIENT_HEIGHT = 192;

interface Props {
  imageUrl?: string | null | undefined;
}

const LandingSidebar = ({ imageUrl }: Props) => {
  const [imageOkay, setImageOkay] = useState(true);

  useEffect(() => {
    if (imageUrl) {
      Image.prefetch(imageUrl)
        .then(() => setImageOkay(true))
        .catch(() => setImageOkay(false));
    } else {
      setImageOkay(false);
    }
  }, [imageUrl]);

  return (
    <View style={{ width: SIDEBAR_WIDTH }}>
      <View>
        <SurfaceGradient />
        <ImageContainer
          source={imageUrl && imageOkay ? { uri: cleanUrl(imageUrl) } : LandingImage}
        />
      </View>
      {IS_WEB && <DownloadOurApp />}
    </View>
  );
};

export default LandingSidebar;

const ImageContainer = styled.Image.attrs({ resizeMode: 'cover' })`
  width: ${SIDEBAR_WIDTH}px;
  height: ${SIDEBAR_WIDTH}px;
`;

const SurfaceGradient = styled(LinearGradient).attrs(({ theme }) => ({
  colors: [transparent(theme.colors.surface, 0), theme.colors.surface]
}))`
  position: absolute;
  bottom: 0px;
  width: ${SIDEBAR_WIDTH}px;
  height: ${GRADIENT_HEIGHT}px;
  z-index: 1;
`;
